(function () {
    'use strict';

    angular
		.module('skillsApp')
		.controller('UserQualityController', UserQualityController);

    function UserQualityController($scope, $state, $stateParams, $translate, $filter, $window, config, logger, userQuality, notifyingService, modalDialogService, dataService, catalogService, jsReportService, documentLinkResolverService) {
        var vm = this;
        vm.item = userQuality;

        var user = config.settings.user;

        if (userQuality.isOwner) {
            vm.notNecessaryEditable = config.settings.notNecessaryByStudent;
        }

        if (user.isAdmin || user.isManager || user.isAssessor) {
            vm.exemptionEditable = user.allowManageExemptions;
            vm.allowDeleteMark = true;
            vm.allowAddMark = !userQuality.notNecessary;
            vm.notNecessaryEditable = vm.notNecessaryEditable || (user.isAdmin || user.isManager);
        }

        vm.showExaminerSelection = userQuality.isOwner || user.isAdmin || user.isManager;

        vm.back = back;
        vm.downloadPdf = downloadPdf;
        vm.getActivityName = getActivityName;
        vm.getStateClass = getStateClass;
        vm.getTotalNumberOfItems = getTotalNumberOfItems;
        vm.openClassical = openClassical;
        vm.openElearning = openElearning;
        vm.openLink = openLink;
        vm.openUserMarkDialog = openUserMarkDialog;
        vm.restartElearning = restartElearning;
        vm.showMarksList = showMarksList;
        vm.userActivityGroupInfo = userActivityGroupInfo;
        vm.now = new Date();

        notifyingService.subscribe($scope, 'userquality-updated', function (event, args) {
            if (args.id !== vm.item.id) return;
            _updateUserQuality(args);
        });

        _initialize(userQuality);
        
        function _initialize(userQuality) {
            return catalogService.getCatalogItems().then(catalogItems => {
                for (var i = 0; i < userQuality.activityGroups.length; i++) {
                    var activities = userQuality.activityGroups[i].activities;
                    for (var j = 0; j < activities.length; j++) {
                        var activity = activities[j];

                        if (!activity.targetId) continue;

                        var ci = _.find(catalogItems, function (item) { return item.targetId === activity.targetId; });
                        if (ci != null) {
                            activity.name = ci.name;
                        } else {
                            activity.name = $translate.instant('catalogitem_not_found');
                            activity.notFound = true;
                        }
                    }
                }

                vm.item = userQuality;
            });
        }

        function _updateUserQuality(userQuality) {
            _initialize(userQuality);
        }

        function back() {
            $state.go('^');
        }

        function downloadPdf() {
            return jsReportService.getUserQualityReport(vm.item);
        }

        function getActivityName(type) {
            var name = type;
            
            switch (type) {
                case 'peerassessment':
                    name = 'peer_assessment';
                    break;
                case 'practical':
                    name = 'practice_test';
                    break;
                case 'skillslabtest':
                    name = 'skillslab_test';
                    break;
                case 'skillslabtraining':
                    name = 'skillslab_training';
                    break;
                case 'trainingonthejob':
                    name = 'training_on_the_job';
                    break;
                case 'writtentest':
                    name = 'written_test';
                    break;
            }
            
            return $translate.instant(name);
        }

        function getStateClass(groupType, activity) {
            if (activity.approved) return 'state-success';
            if (groupType === 'recommended') return 'state-warning';
            return 'state-danger';
        }

        function getTotalNumberOfItems(group) {
            var totalItems = 0;
            for (var prop in group) {
                if (angular.isArray(group[prop])) {
                    totalItems += group[prop].filter(function (item) {
                        return !item.notApplicable;
                    }).length;
                }
            }
            return totalItems;
        }

        function openClassical(activity) {
                        
            if (activity.currentStatus === 'completed') {
                var message = $translate.instant('the_result_is_valid_until') + ' ' + $filter('date')(activity.dateOfExpiry, 'dd-MM-yyyy') + '. ' + $translate.instant('are_you_sure_you_want_to_register_again?');
                return modalDialogService.confirmYesNo(activity.name, message, () => { $window.location = config.portalUrl + '/Members/cep/' + activity.targetId; });
            }

            if (activity.currentStatus === 'registered') {
                $window.location = config.portalUrl + '/Members/calendar';
                return true;
            }

            $window.location = config.portalUrl + '/Members/cep/' + activity.targetId;
            return true;
        }

        function openElearning(activity) {
            return catalogService.startElearning(activity.targetId).then(url => { $window.location = url; });
        }

        function openLink(activity, ev) {
            documentLinkResolverService.linkClicked(activity, ev);
        }

        function openUserMarkDialog(activity) {

            var title = activity.name;
            var message = $translate.instant('have_you_read_the_' + activity.type + '?');
            
            modalDialogService.confirmYesNo(title, message, () => {
                dataService.saveMark(vm.item.id, null, activity.id, new Date(), true).then(() => {
                    logger.success('successfully_saved');
                });
            });
        }

        function restartElearning(activity) {
            // restart
            var message = '';

            if (activity.approved) {
                message = $translate.instant('the_result_is_valid_until') + ' ' + $filter('date')(activity.dateOfExpiry, 'dd-MM-yyyy') + '. ' + $translate.instant('are_you_sure_you_want_to_go_ahead?');
            } else {
                message = $translate.instant('are_you_sure_you_want_to_restart_this_elearning?');
            }

            return modalDialogService.confirmYesNo(activity.name, message, () => {
                return catalogService.restartElearning(activity.targetId).then((url) => { $window.location = url; });
            });
        }

        function showMarksList(activity) {
            switch (activity.type) {
                case 'classical':
                    return !activity.targetId;
                case 'skillslabtraining':
                case 'skillslabtest':
                case 'trainingonthejob':
                case 'writtentest':
                case 'practical':
                case 'peerassessment':
                    return true;
                default:
                    return false;
            }
        }

        function userActivityGroupInfo(group) {
            var info = { totalItems: 0, totalApproved: 0 };
            for (var prop in group) {
                if (angular.isArray(group[prop])) {
                    info.totalItems += group[prop].length;
                    for (var i = 0; i < group[prop].length; i++) {
                        info.totalApproved += (group[prop][i].approved) ? 1 : 0;
                    }
                }
            }
            return info;
        }
    }
})();